<template>
  <div
    class="phase-operation"
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
  >
    <div class="stage_step" :style="topStyle">
      <div class="title">
        {{ activityData.activityBeginTime | timeFormater }}～{{
          activityData.activityEndTime | timeFormater
        }}参与活动领大礼包!
      </div>
      <div class="content">
        <div class="top" :class="{ 'no-join': canJoin }">
          <div class="tip">
            （
            <span v-if="stageTask.stageType === 2">
              {{ stageTask.stageBeginTime | timeFormater }}～{{
                stageTask.stageEndTime | timeFormater
              }}日
            </span>
            <span v-else>本阶段内</span>
            {{ stageName }}
            ）
          </div>
          <div :class="statusDescClass">
            <template v-if="stageTask.stageStatus === 5">
              您<span>{{ stageTask.lastStageIncompleteValue }}</span
              >日未达到活动要求，<span
                >{{ stageTask.stageBeginTime | timeFormater }}-{{
                  stageTask.stageEndTime | timeFormater
                }}</span
              >参与活动可得
            </template>
            <template v-else-if="stageTask.stageStatus === 4">
              当前已无法参与活动，下次早点来哦
            </template>
            <template v-else-if="stageTask.stageStatus === 3">
              已{{ taskProgress.taskType === 1 ? '连续' : '累计' }}购买<span>{{
                taskProgress.completedValue
              }}</span
              >{{ activityData.styleType | unit }}，已获得
            </template>
            <template v-else>
              已{{ taskProgress.taskType === 1 ? '连续' : '累计' }}买<span>{{
                taskProgress.completedValue
              }}</span
              >{{ activityData.styleType | unit }}，再买<span>{{
                taskProgress.incompleteValue
              }}</span
              >{{ activityData.styleType | unit }}可获得
            </template>
          </div>

          <div class="value">
            <span class="unit">¥</span>
            <span class="price">
              {{ taskProgress.presentStageCouponMoney }}
              <span class="gift-desc">优惠券大礼包</span>
            </span>
          </div>
          <div class="desc">
            {{ module.data.otherData.subTitle }}
          </div>
        </div>
        <div
          class="progress-wrap"
          :class="{ 'row-center': taskProgress.completedValue <= 5 }"
        >
          <money-progress
            v-if="activityData.styleType === 2"
            :start-money="taskProgress.completedValue"
            :end-money="
              taskProgress.incompleteValue + taskProgress.completedValue
            "
            :rewards="taskProgress.presentStageCouponMoney"
          />
          <activity-progress
            v-else
            :progress-list="progressList"
            :stage-money="taskProgress.presentStageCouponMoney"
            :can-join="canJoin"
          />
        </div>
      </div>
    </div>
    <div class="stage_result" :style="rewardsStyle">
      <div class="rewards-wrap">
        <div class="total">
          <span class="desc">若全程参与活动，可获得礼金金额共计：</span>
          <span class="unit">¥</span>
          <span class="value">{{ activityData.totalRewardAmount }}</span>
        </div>
        <div class="now">
          <span class="desc">当前达成：</span>
          <span class="unit">¥</span>
          <span class="value">{{ activityData.gotRewardAmount }}</span>
        </div>
        <div class="feather">
          <span class="desc">后续可达成：</span>
          <span class="unit">¥</span>
          <span class="value">{{ activityData.futureRewardAmount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ossImage } from '@/utils/oss_image'
import { dateTimeFormatter } from '@/utils/utils'

import ActivityProgress from '../components/ActivityProgress'
import MoneyProgress from '../components/MoneyProgress'
const STAGE_STATUS = {
  noStart: 1,
  going: 2,
  completed: 3,
  incomplete: 4,
  break: 5
}

export default {
  name: 'PhaseOperations',
  filters: {
    timeFormater(value) {
      return dateTimeFormatter(value * 1000, 'M.DD')
    },
    unit(val) {
      let unit = ''
      switch (val) {
        case 1:
          unit = '天'
          break
        case 2:
          unit = '元'
          break
        default:
          unit = '天'
          break
      }
      return unit
    }
  },
  components: {
    ActivityProgress,
    MoneyProgress
  },
  props: {
    module: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    statusDescClass() {
      return this.stageTask.stageStatus === STAGE_STATUS.break
        ? 'failed'
        : 'continuous'
    },
    topStyle() {
      if (this.module.backgroundImage) {
        return {
          backgroundImage:
            'url(' + this.ossImage({ src: this.module.backgroundImage }) + ')'
        }
      } else {
        return ''
      }
    },
    rewardsStyle() {
      if (this.module.data.otherData.img) {
        return {
          backgroundImage:
            'url(' +
            this.ossImage({ src: this.module.data.otherData.img }) +
            ')'
        }
      } else {
        return ''
      }
    },
    activityData() {
      return this.module.data
    },
    stageTask() {
      return this.activityData.stageTask
    },
    taskProgress() {
      return this.stageTask.taskProgress
    },
    canJoin() {
      return this.stageTask.stageStatus === STAGE_STATUS.incomplete
    },
    stageName() {
      return this.taskProgress.taskDesc
    },
    progressList() {
      return this.taskProgress.progressList
    }
  },
  methods: {
    ossImage
  }
}
</script>

<style lang="scss" scoped>
.stage_step {
  height: 6.8rem;
  background-size: 100% 100%;

  background-repeat: no-repeat;
  .title {
    padding: 0.27rem 0 0.26rem;

    font-size: 0.28rem;
    line-height: 0.28rem;
    text-align: center;
    color: #333333;
  }
  .content {
    width: 6.9rem;
    margin: 0 auto;
  }
  .top {
    height: 4.28rem;

    background-color: #fffcf5;
    background-image: url('../images/huodongjieduan.png');
    background-repeat: no-repeat;
    border-radius: 0.3rem 0.3rem 0 0;
    background-size: 100% 100%;
    .tip {
      padding: 0.4rem 0 0.24rem;

      font-size: 0.28rem;
      line-height: 0.28rem;
      text-align: center;
      color: rgba(51, 51, 51, 0.8);
    }
    .continuous {
      margin-bottom: 0.6rem;

      font-size: 0.32rem;
      line-height: 0.3rem;
      font-weight: bold;
      text-align: center;
      color: #333333;
      span {
        margin: 0 0.1rem;

        color: #ff9b3a;
      }
    }
    .failed {
      width: 5.87rem;
      margin: 0 auto 0.05rem;

      font-size: 0.32rem;
      line-height: 0.45rem;
      color: #333;
      span {
        margin: 0 0.05rem;

        color: #f9791a;
      }
    }
    .value {
      font-size: 0;
      text-align: center;
      color: #f47b21;
      .unit {
        font-size: 0.48rem;
        color: #f47b21;
      }
      .price {
        display: inline-block;

        position: relative;

        margin-left: 0.14rem;

        font-size: 1.2rem;
        line-height: 0.8rem;
        color: #f47b21;
      }
      .gift-desc {
        position: absolute;
        top: -0.1rem;
        right: -1.7rem;

        width: 1.66rem;
        height: 0.42rem;

        background-color: #fff4dc;
        border-radius: 0.25rem 0.21rem 0.21rem 0;

        font-size: 0.24rem;
        line-height: 0.42rem;
        text-align: center;
        color: #f47b21;
      }
    }
    .desc {
      margin-top: 0.45rem;

      font-size: 0.28rem;
      line-height: 0.28rem;
      text-align: center;
      color: #333;
    }
    &.no-join {
      background-image: url('../images/huodongjieduan-zhihui.png');
      .tip {
        color: #999;
      }
      .value {
        .unit,
        .price {
          color: #999;
        }
        .gift-desc {
          background-color: #e1e1e1;
        }
      }
      .desc {
        color: #999;
      }
    }
  }
  .progress-wrap {
    display: flex;

    height: 1.7rem;

    background-color: #fffcf5;
    border-radius: 0 0 0.3rem 0.3rem;
    overflow-x: scroll;
    &.row-center {
      justify-content: center;
    }
  }
}
.stage_result {
  position: relative;

  height: 5.67rem;

  background-repeat: no-repeat;
  background-size: 100% 100%;
  .rewards-wrap {
    position: absolute;
    bottom: 0.55rem;
    left: 50%;
    transform: translateX(-50%);

    width: 6.9rem;
    height: 2.49rem;
    padding: 0.4rem;

    background-image: url('../images/renwuzonglan-bg.png');
    background-repeat: no-repeat;
    border-radius: 0.2rem;

    font-size: 0;
    line-height: 0.28rem;
    color: rgba(51, 51, 51, 0.9);
    box-sizing: border-box;
    background-size: 100% 100%;
    .total {
      padding-bottom: 0.2rem;

      border-bottom: 1px dotted rgba(255, 155, 58, 0.5);
      .value {
        font-size: 0.48rem;
      }
    }
    span.desc {
      font-size: 0.28rem;
    }
    span.unit {
      display: inline-block;

      font-size: 0.24rem;
      color: #f9791a;
    }
    span.value {
      display: inline-block;

      font-size: 0.34rem;
      color: #f9791a;
    }
    .now {
      padding: 0.2rem 0 0.1rem;
    }
  }
}
</style>
